import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { INTELLIGENCE } from "../homeData";
import { Window } from "../HW";
import { useAiCycle } from "../AiPrompt";

const ease = [0.2, 0.8, 0.2, 1];

// TRAIDE Intelligence inside the product: ask anything, and the standing insights it keeps watch over.
export default function Ai({ height, active = true }) {
  const { p, typed, phase } = useAiCycle(active);
  const answered = phase === "answer" || phase === "lines";
  return (
    <Window active="Home" crumb={<>TRAIDE Intelligence <span className="font-normal text-[#A1A1AA]">· across your business</span></>} testid="hw-ai" height={height}>
      <div className="grid grid-cols-5 gap-3 px-4 pt-3.5">
        <div className="col-span-3">
          <div className="rounded-lg border border-[#ECECEE] bg-[#FAFAFB] p-3">
            <div className="flex items-center gap-2 text-[12.5px]"><span className="ai-icon"><Sparkles /></span><span className="min-w-0 flex-1 truncate"><span className="text-[#A1A1AA]">Ask TRAIDE · </span>{typed}{phase === "typing" && <span className="ai-cursor" />}</span>{phase === "thinking" && <span className="ai-think"><i /><i /><i /></span>}</div>
          </div>
          <div className="mt-2 min-h-[150px] rounded-lg border border-[#ECECEE] p-3">
            {answered ? (
              <motion.div key={p.q} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, ease }}>
                <div className="text-[13px] font-semibold">{p.a}</div>
                {phase === "lines" && <ul className="mt-2 space-y-1.5">{p.lines.map((l, n) => <motion.li key={l} initial={{ opacity: 0, x: -6 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 + n * 0.5, duration: 0.3, ease }} className="flex items-start gap-2 text-[12px] text-[#27272A]"><span className="mt-[6px] h-1 w-1 shrink-0 rounded-full bg-amber-500" />{l}</motion.li>)}</ul>}
                {phase === "lines" && <div className="mt-3 flex gap-1.5"><span className="hw-btn dark">Do it</span><span className="hw-btn">Show me</span></div>}
              </motion.div>
            ) : <div className="text-[12px] text-[#A1A1AA]">TRAIDE reads your jobs, quotes, schedule, suppliers and invoices — then answers in plain English.</div>}
          </div>
        </div>
        <div className="col-span-2 overflow-hidden rounded-lg border border-[#ECECEE]">
          <div className="px-3 py-1.5 text-[12px] font-semibold">Watching for you</div>
          {INTELLIGENCE.map((it, i) => <motion.div key={it.kind} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * i, duration: 0.3, ease }} className="hw-row !items-start !py-2"><span className="mt-0.5 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500" /><span className="min-w-0"><span className="block text-[10px] font-semibold uppercase tracking-wider text-[#71717A]">{it.kind} · {it.badge}</span><span className="block text-[11.5px] leading-snug">{it.text}</span></span></motion.div>)}
        </div>
      </div>
    </Window>
  );
}
